// src/components/Header.jsx
import React from 'react';
import logo from '../../assets/mora-logo.png'; // Correct path to the logo in src/assets/


const Header = () => {
  return (
    <div className="header">
      <img src={logo} alt="Logo" className="logo" />
      <h1>Server Room Monitoring Dashboard</h1>
    </div>
  );
};

export default Header;